import * as icons from '@/components/svg/flight';

export const amenities = {
  '06R': {
    txt: 'Accumulo miglia',
    icon: 'default_icon',
    tooltip: '',
  },
  '09D': {
    txt: 'Accumulo miglia',
    icon: 'default_icon',
    tooltip: '',
  },
  '0AV': {
    txt: 'Alcolici a bordo',
    icon: 'default_icon',
    tooltip: '',
  },
  '0AX': {
    txt: 'Bevande',
    icon: 'default_icon',
    tooltip: '',
  },
  '09P': {
    txt: 'Bagaglio in cabina',
    icon: 'handy_bag',
    tooltip: '',
  },
  '0MR': {
    txt: 'Bagaglio cabina 1 pezzo da 12 kg',
    icon: 'handy_bag',
    tooltip: '',
  },
  '0MS': {
    txt: 'Bagaglio in cabina da 18 kg 2 pezzi',
    icon: 'handy_bag',
    tooltip: '',
  },
  '010': {
    txt: 'Bagaglio a mano',
    icon: 'handy_bag',
    tooltip: '',
  },
  '0L5': {
    txt: 'Bagaglio a mano piccolo 40x20x25',
    icon: 'personal_item',
    tooltip: '',
  },
  '0MU': {
    txt: 'Bagaglio a mano 115 cm',
    icon: 'handy_bag',
    tooltip: '',
  },
  '0M3': {
    txt: 'Bagaglio a mano: max 7 kg, 45 L, dimensioni totali max 115 cm',
    icon: 'handy_bag',
    tooltip: '',
  },
  '06I': {
    txt: 'Cambi prima della partenza',
    icon: 'default_icon',
    tooltip: '',
  },
  '059': {
    txt: 'Biglietto modificabile',
    icon: 'default_icon',
    tooltip: '',
  },
  '0FA': {
    txt: 'Bagagli stiva 2 da 23 kg',
    icon: 'added_bag',
    tooltip: '',
  },
  '0CC': {
    txt: 'Primo bagaglio stiva',
    icon: 'added_bag',
    tooltip: '',
  },
  '0CD': {
    txt: 'Secondo bagaglio stiva',
    icon: 'added_bag',
    tooltip: '',
  },
  '0CH': {
    txt: 'Bagaglio in stiva',
    icon: 'added_bag',
    tooltip: '',
  },
  '0GO': {
    txt: 'Bagaglio stiva 23 kg dimensioni 158 totali',
    icon: 'added_bag',
    tooltip: '',
  },
  '050': {
    txt: 'Posto standard',
    icon: 'default_icon',
    tooltip: '',
  },
  CML: {
    txt: 'Pasto gratuito',
    icon: 'default_icon',
    tooltip: '',
  },
  '0B1': {
    txt: 'Intrattenimento a bordo',
    icon: 'default_icon',
    tooltip: '',
  },
  BG1: {
    txt: 'Primo bagaglio da stiva 23 kg',
    icon: 'added_bag',
    tooltip: '',
  },
  '06D': {
    txt: 'Accumulo miglia',
    icon: 'default_icon',
    tooltip: '',
  },
  OEA: {
    txt: 'Intrattenimento a bordo',
    icon: 'default_icon',
    tooltip: '',
  },
  '0CL': {
    txt: 'Accesso internet',
    icon: 'default_icon',
    tooltip: '',
  },
  '04H': {
    txt: 'Accesso internet',
    icon: 'default_icon',
    tooltip: '',
  },
  '0BX': {
    txt: 'Accesso lounge',
    icon: 'default_icon',
    tooltip: '',
  },
  '0B3': {
    txt: 'Cibo e bevande',
    icon: 'default_icon',
    tooltip: '',
  },
  '057': {
    txt: 'Accumulo miglia',
    icon: 'default_icon',
    tooltip: '',
  },
  '0CM': {
    txt: 'Accumulo miglia',
    icon: 'default_icon',
    tooltip: '',
  },
  '04D': {
    txt: 'Upgrade a pagamento',
    icon: 'default_icon',
    tooltip: '',
  },
  '04J': {
    txt: 'Oggetti personali',
    icon: 'default_icon',
    tooltip: 'una piccola borsetta, una piccola borsa per laptop o un piccolo zaino',
  },
  PSL: {
    txt: 'Oggetti personali',
    icon: 'default_icon',
    tooltip: 'una piccola borsetta, una piccola borsa per laptop o un piccolo zaino',
  },
  '0B5': {
    txt: 'Preassegnazione posti',
    icon: 'default_icon',
    tooltip: '',
  },
  PQC: {
    txt: 'Premi a credito',
    icon: 'default_icon',
    tooltip: '',
  },
  '05Z': {
    txt: 'Posto a sedere con spazio gambe e posto su uscita emergenza',
    icon: 'default_icon',
    tooltip: '',
  },
  '0G6': {
    txt: 'Imbarco prioritario',
    icon: 'default_icon',
    tooltip: '',
  },
  '03P': {
    txt: 'Priorità check in',
    icon: 'default_icon',
    tooltip: '',
  },
  '0LW': {
    txt: 'Controlli sicurezza snelli e priorità',
    icon: 'default_icon',
    tooltip: '',
  },
  '056': {
    txt: 'Biglietto rimborsabile',
    icon: 'default_icon',
    tooltip: '',
  },
  SDC: {
    txt: 'Cambio lo stesso giorno',
    icon: 'default_icon',
    tooltip: '',
  },
  PSA: {
    txt: 'Posti preassegnati',
    icon: 'default_icon',
    tooltip: '',
  },
  BG2: {
    txt: 'Secondo bagaglio in stiva 23 kg',
    icon: 'added_bag',
    tooltip: '',
  },
  '07G': {
    txt: 'Sky Priority',
    icon: 'default_icon',
    tooltip: '',
  },
  '0AT': {
    txt: 'Snack',
    icon: 'default_icon',
    tooltip: '',
  },
  STS: {
    txt: 'Posti standard',
    icon: 'default_icon',
    tooltip: '',
  },
  '0BH': {
    txt: 'Minori non accompagnati',
    icon: 'default_icon',
    tooltip: '',
  },
  '058': {
    txt: 'Possibilità upgrade',
    icon: 'default_icon',
    tooltip: '',
  },
  '0MM': {
    txt: 'Oggetti personali',
    icon: 'default_icon',
    tooltip: '',
  },
  '0MQ': {
    txt: 'Bagaglio a mano dimensioni 115 totali',
    icon: 'handy_bag',
    tooltip: '',
  },
  '06J': {
    txt: 'Cambi dopo la partenza',
    icon: 'default_icon',
    tooltip: '',
  },
  '0IK': {
    txt: 'Bagagli in eccesso',
    icon: 'default_icon',
    tooltip: '',
  },
  '0C2': {
    txt: 'Bagaglio stiva 20 kg',
    icon: 'added_bag',
    tooltip: '',
  },
  '0L7': {
    txt: 'Cambio nome',
    icon: 'default_icon',
    tooltip: '',
  },
  '0LF': {
    txt: 'Bagaglio prioritario',
    icon: 'default_icon',
    tooltip: '',
  },
  '0CZ': {
    txt: 'Bagaglio cabina 10 kg',
    icon: 'handy_bag',
    tooltip: '',
  },
  '0MJ': {
    txt: 'Bagaglio cabina 10 kg',
    icon: 'handy_bag',
    tooltip: '',
  },
  IB4: {
    txt: 'Posto standard selezionabile 24 ore prima della partenza',
    icon: 'default_icon',
    tooltip: '',
  },
  '077': {
    txt: 'Bagaglio personale a bordo',
    icon: 'default_icon',
    tooltip: '',
  },
  IB0: {
    txt: 'Programma fedeltà',
    icon: 'default_icon',
    tooltip: '',
  },
  IB1: {
    txt: 'Programma fedeltà elite',
    icon: 'default_icon',
    tooltip: '',
  },
  IB5: {
    txt: 'Posto xl',
    icon: 'default_icon',
    tooltip: '',
  },
  IB3: {
    txt: 'Scelta posto anteriore',
    icon: 'default_icon',
    tooltip: '',
  },
  IC3: {
    txt: 'Snack e bevande',
    icon: 'default_icon',
    tooltip: '',
  },
  '09A': {
    txt: 'Wifi a bordo',
    icon: 'default_icon',
    tooltip: '',
  },
  '068': {
    txt: 'Modifica sempre',
    icon: 'default_icon',
    tooltip: '',
  },
  '0CE': {
    txt: 'Terzo bagaglio stiva',
    icon: 'added_bag',
    tooltip: '',
  },
  IB7: {
    txt: 'Rimborsabile sempre',
    icon: 'default_icon',
    tooltip: '',
  },
  '0C3': {
    txt: 'Bagaglio stiva 1 pezzo da 23 kg',
    icon: 'added_bag',
    tooltip: '',
  },
  GSH: {
    txt: 'Go show',
    icon: 'default_icon',
    tooltip: '',
  },
  '09Q': {
    txt: 'Bagaglio in cabina 8 kg',
    icon: 'handy_bag',
    tooltip: '',
  },
  FBY: {
    txt: 'Bagaglio in stiva 23 kg',
    icon: 'added_bag',
    tooltip: '',
  },
  '07H': {
    txt: 'Cambio del volo il giorno della partenza per uno precedente',
    icon: 'default_icon',
    tooltip: '',
  },
  PSG: {
    txt: 'Controlli di sicurezza prioritari in Germania',
    icon: 'default_icon',
    tooltip: '',
  },
  PSF: {
    txt: 'Controlli di sicurezza prioritari in Brussels',
    icon: 'default_icon',
    tooltip: '',
  },
  '018': {
    txt: 'Catering a bordo',
    icon: 'default_icon',
    tooltip: '',
  },
  PZS: {
    txt: 'Posti con spazio per le gambe',
    icon: 'default_icon',
    tooltip: '',
  },
  '06K': {
    txt: 'Rimborso prima della partenza',
    icon: 'default_icon',
    tooltip: '',
  },
  '06L': {
    txt: 'Rimborso dopo la partenza',
    icon: 'default_icon',
    tooltip: '',
  },
  SEA: {
    txt: 'Posto a sedere vicino libero',
    icon: 'default_icon',
    tooltip: '',
  },
  '0AA': {
    txt: 'Bagaglio prepagato',
    icon: 'default_icon',
    tooltip: '',
  },
  P01: {
    txt: 'Bagaglio stiva gratuito',
    icon: 'added_bag',
    tooltip: '',
  },
  A25: {
    txt: 'Bagaglio stiva gratuito 25 kg',
    icon: 'added_bag',
    tooltip: '',
  },
  '0D4': {
    txt: 'Attrezzatura golf',
    icon: 'default_icon',
    tooltip: '',
  },
  '05U': {
    txt: 'Accumulo miglia',
    icon: 'default_icon',
    tooltip: '',
  },
  '0NN': {
    txt: 'Penali no show',
    icon: 'default_icon',
    tooltip: '',
  },
  '0H6': {
    txt: 'Costo peso in eccesso',
    icon: 'default_icon',
    tooltip: '',
  },
  SA4: {
    txt: 'Posto vicino libero',
    icon: 'default_icon',
    tooltip: '',
  },
  '09C': {
    txt: 'Accumulo miglia',
    icon: 'default_icon',
    tooltip: '',
  },
  A30: {
    txt: 'Bagaglio stiva 30 kg gratis',
    icon: 'added_bag',
    tooltip: '',
  },
  '06C': {
    txt: 'Accumulo miglia',
    icon: 'default_icon',
    tooltip: '',
  },
  BAG: {
    txt: 'Bagaglio incluso',
    icon: 'default_icon',
    tooltip: '',
  },
  '0AK': {
    txt: 'Pasto',
    icon: 'default_icon',
    tooltip: '',
  },
  CNR: {
    txt: '',
    icon: 'default_icon',
    tooltip: '',
  },
  '0BN': {
    txt: 'Autista',
    icon: 'default_icon',
    tooltip: '',
  },
  '0KX': {
    txt: 'Bagaglio mano 14 kg',
    icon: 'handy_bag',
    tooltip: '',
  },
  '06H': {
    txt: 'Accumulo miglia',
    icon: 'default_icon',
    tooltip: '',
  },
  '029': {
    txt: 'Imbarco veloce',
    icon: 'default_icon',
    tooltip: '',
  },
  '0AW': {
    txt: 'No alcolici',
    icon: 'default_icon',
    tooltip: '',
  },
  '02Q': {
    txt: 'USB a bordo',
    icon: 'default_icon',
    tooltip: '',
  },
  '05T': {
    txt: 'Accredito punti',
    icon: 'default_icon',
    tooltip: '',
  },
  BRD: {
    txt: 'Ultimo a salire a bordo',
    icon: 'default_icon',
    tooltip: '',
  },
  BIN: {
    txt: 'Spazio limitato cappelliera',
    icon: 'default_icon',
    tooltip: '',
  },
  SBO: {
    txt: 'Imbarco standard',
    icon: 'default_icon',
    tooltip: '',
  },
  MDL: {
    txt: 'Accumulo punti',
    icon: 'default_icon',
    tooltip: '',
  },
  '0E8': {
    txt: 'Bagaglio in stiva 23 kg 140 cm',
    icon: 'added_bag',
    tooltip: '',
  },
  '055': {
    txt: 'Penale per cambio data',
    icon: 'default_icon',
    tooltip: '',
  },
  '08S': {
    txt: 'Cambio biglietto stesso giorno della partenza',
    icon: 'default_icon',
    tooltip: '',
  },
  '0GP': {
    txt: '1 bagaglio max 23 kg cm 208',
    icon: 'added_bag',
    tooltip: '',
  },
  '0MO': {
    txt: 'Bagaglio in cabina 23 kg cm 55x45x25',
    icon: 'handy_bag',
    tooltip: '',
  },
  CB1: {
    txt: 'Bagaglio sotto il sedile 88 cm',
    icon: 'default_icon',
    tooltip: '',
  },
  FB1: {
    txt: '1 bagaglio da stiva 23 kg',
    icon: 'added_bag',
    tooltip: '',
  },
  CB2: {
    txt: 'Bagaglio a mano fino a 10kg',
    icon: 'handy_bag',
    tooltip: '',
  },
  FB2: {
    txt: '2 bagagli stiva 23kg',
    icon: 'added_bag',
    tooltip: '',
  },
  CB3: {
    txt: 'Bagaglio in cabina 15 kg',
    icon: 'handy_bag',
    tooltip: '',
  },
  '0C5': {
    txt: 'Bagaglio stiva 30 kg',
    icon: 'added_bag',
    tooltip: '',
  },
  '0C7': {
    txt: 'Bagaglio stiva 35 kg',
    icon: 'added_bag',
    tooltip: '',
  },
  '06P': {
    txt: 'Accumulo miglia',
    icon: 'default_icon',
    tooltip: '',
  },
  '0EO': {
    txt: 'Compensazioni emissioni carburante',
    icon: 'default_icon',
    tooltip: '',
  },
  '019': {
    txt: 'Catering a bordo',
    icon: 'default_icon',
    tooltip: '',
  },
  '09E': {
    txt: 'Accumulo miglia',
    icon: 'default_icon',
    tooltip: '',
  },
  '0FL': {
    txt: 'Bagaglio da stiva 30kg',
    icon: 'added_bag',
    tooltip: '',
  },
  '0MZ': {
    txt: 'Bagaglio in cabina 6kg',
    icon: 'handy_bag',
    tooltip: '',
  },
  '06B': {
    txt: 'Accumulo miglia',
    icon: 'default_icon',
    tooltip: '',
  },
  M02: {
    txt: 'Accumulo miglia',
    icon: 'default_icon',
    tooltip: '',
  },
  P02: {
    txt: '2 bagagli stiva 23kg',
    icon: 'added_bag',
    tooltip: '',
  },
  M06: {
    txt: 'Accumulo miglia',
    icon: 'default_icon',
    tooltip: '',
  },
  M07: {
    txt: 'Accumulo miglia',
    icon: 'default_icon',
    tooltip: '',
  },
  CBY: {
    txt: 'Bagaglio a mano 8kg',
    icon: 'handy_bag',
    tooltip: '',
  },
  '06M': {
    txt: 'Accumulo miglia',
    icon: 'default_icon',
    tooltip: '',
  },
};

export function get_amenity_info(amenity) {
  // se non trovo il codice desiderato nelle amenities codificate restituisco lo stesso oggetto con i campi ui_ replicati da quello che trovo dall'api
  if (amenity.code in amenities == false)
    return {
      ...amenity,
      txt: amenity.description,
      icon: icons['default_icon'],
      description: '',
    };

  let filtered = amenities[amenity.code];

  return {
    ...filtered,
    icon: icons[filtered.icon] ? icons[filtered.icon] : icons['default_icon'],
    txt: filtered.txt ? filtered.txt : amenity.description,
    description: filtered.description ? filtered.description : '',
  };
}
